module.exports = __webpack_public_path__ + "static/media/scrubber.f8ed98cc.svg";